// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__3V5JV","name":"ConsentHeader_name__zodOm","birthday":"ConsentHeader_birthday__1iDN1","skeleton":"ConsentHeader_skeleton__3_wb8"};